import { observer } from 'mobx-react';
import * as React from 'react';
import ParticipantsStore from '../../../../../ParticipantsStore';
import { PlusIcon } from '@heroicons/react/20/solid';

interface Props {
  participantsStore: ParticipantsStore;
}

const SelectAll: React.FC<Props> = ({ participantsStore }) => (
  <div
    className="mr-1 h-5 w-5 flex items-center cursor-pointer bg-teal-600 text-white rounded-sm"
    data-intercom-target="select-all-participants"
    onClick={() => participantsStore.selectAll()}
  >
    <PlusIcon className="h-5 w-5" aria-hidden="true" />
  </div>
);
export default observer(SelectAll);
